import styled, { css } from 'styled-components';

export const Container = styled.div(
  () => css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    & svg {
      width: 100%;
      height: 100%;
    }
  `,
);
